import get from 'lodash/get';

import {
  SET_FEEDBACK_OPEN,
  CREATE_FEEDBACK_ITEM,
  DELETE_FEEDBACK_ITEM,
  SELECT_FEEDBACK_ITEM,
  UPDATE_FEEDBACK_ITEM
} from './actions';

export const initialState = {
  isFeedbackOpen: false,
  selectedFeedbackItem: null,
  feedbackItems: {}
};

export const studioFeedbackReducerKey = 'studioFeedback';

export const studioFeedbackReducer = (state = initialState, { type = '', payload = {} } = {}) => {
  switch (type) {
    case SET_FEEDBACK_OPEN:
      return {
        ...state,
        isFeedbackOpen: payload.isOpen
      };
    case CREATE_FEEDBACK_ITEM:
      return {
        ...state,
        feedbackItems: {
          ...state.feedbackItems,
          [payload.feedbackItem.id()]: payload.feedbackItem
        }
      };
    case DELETE_FEEDBACK_ITEM:
      const { [payload.id]: _, ...rest } = state.feedbackItems;
      return {
        ...state,
        feedbackItems: rest,
        selectedFeedbackItem: state.selectedFeedbackItem === payload.id ? null : state.selectedFeedbackItem
      };
    case SELECT_FEEDBACK_ITEM:
      return {
        ...state,
        selectedFeedbackItem: payload.id
      };
    case UPDATE_FEEDBACK_ITEM:
      const feedbackItem = get(state, `feedbackItems.${payload.id}`);
      if (!feedbackItem || !feedbackItem.makeCopy) {
        return state;
      }
      return {
        ...state,
        feedbackItems: {
          ...state.feedbackItems,
          [payload.id]: feedbackItem.makeCopy({ ...payload.updateData })
        }
      };
    default:
      return state;
  }
};
